import SetCreatedPharmacyTagModal from './SetCreatedPharmacyTagModal';

export default SetCreatedPharmacyTagModal;
